import { render, staticRenderFns } from "./addThirdPanel.vue?vue&type=template&id=23286774&"
import script from "./addThirdPanel.vue?vue&type=script&lang=js&"
export * from "./addThirdPanel.vue?vue&type=script&lang=js&"
import style0 from "./addThirdPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports